import { Flex, Text } from '@chakra-ui/react'

export const Total = ({ total }) => (
  <Flex pointerEvents='none' mr='1rem' minW='10%'>
    <Text fontSize='sm' fontWeight='bold'>{total}</Text>
  </Flex>
)
